<template>
  <div>
    <p class="m-t-3 recipe-form__subtitle">
      {{ capitalize($i18n.t('elements.thematic.text.choose')) }}
    </p>
    <SemanticSelect
       v-model="recipeThematics"
       :options="thematics"
       :placeholder="$i18n.t('elements.thematic.text.index')"
       :multiple="true"
       :disabled="locked"
       select-class="ui multiple search dropdown pointing top left custom-dropdown recipe-form__dropdown recipe-from__dropdown--thematics recipe-form__dropdown--big selection"
       />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { inflection, api } from './mixins'
import SemanticSelect from './SemanticSelect.vue'

export default{
  mixins: [inflection, api],
  components: { SemanticSelect },
  data () {
    return {
      recipeThematics: null,
      locked: false
    }
  },
  watch: {
    recipeThematics: {
      handler: 'updateThematics',
      deep: true
    }
  },
  computed: {
    ...mapGetters(['recipeData', 'thematics'])
  },
  methods: {
    updateThematics (newVal, oldVal) {
      if (!oldVal) { return }

      const updateParams = {
        association: {
          model_name: 'Thematic',
          ids_list: newVal
        }
      }

      this.locked = true
      this.sendRequest('put', `${this.recipePath}/update_association`, updateParams)
      .then( () => this.locked = false )
      .catch( () => this.locked = false )
    }
  },
  created () {
    this.recipeThematics = (this.recipeData.thematics || []).map( (c) => c.id )
  }
}
</script>

<style lang="stylus" scoped>
</style>
